module.exports = __webpack_public_path__ + "static/media/Apartment.d61defbc.png";